const ErrorPage = () => {
  return (
    <div className="contact-res">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 contact-icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <p>Sorry, the server has problem now.</p>
      <p>Please call or email us!</p>
      <p>kiamasushi@gmail.com</p>
      <p>404 515 076</p>
    </div>
  );
};

export default ErrorPage;
